// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__342aL","colBig":"styles_colBig__3N-v2","colSmall":"styles_colSmall__3Vsih"};